import { Grid as ChakraGrid } from "@chakra-ui/react";
import { forwardRef, type ComponentProps } from "react";
import type { GridSharedProps } from "./Grid.props";

type ChakraGridProps = ComponentProps<typeof ChakraGrid>;

export type GridProps = GridSharedProps & {
  // Add any web specific props here.
};

const Grid = forwardRef<HTMLDivElement, GridProps>(function Grid(props, ref) {
  return <ChakraGrid ref={ref} {...(props as unknown as ChakraGridProps)} />;
});

export default Grid;
